import { Box, Center, Flex, Grid, SystemStyleObject, Text } from '@chakra-ui/react';
import { useMemo } from 'react';

import {
  AccordionItem,
  AccordionItemContent,
  AccordionItemTrigger,
  Checkbox,
  Switch,
} from '../../../components';
import { customScrollbarStyles, pxToRem } from '../../../theme';
import { StringTraitsWithCountType, useKollections } from '../KollectionsProvider';

export function KollectionsFilterGroupToggle() {
  const { booleanTraits, setBooleanTrait } = useKollections();

  return (
    <Flex alignItems="center" justifyContent="space-between" borderBottom="thin" py={4}>
      <Box fontWeight="medium" textTransform="uppercase" fontSize="md">
        Legendary
      </Box>
      <Switch checked={booleanTraits.legendary} onChange={() => setBooleanTrait('legendary')} />
    </Flex>
  );
}

function KollectionsFilterGroupCheckboxListItem({
  value,
  count,
  onChange,
  isChecked,
}: {
  value: string;
  count: number;
  onChange: () => void;
  isChecked: boolean;
}) {
  return useMemo(
    () => (
      <Checkbox width="100%" display="flex" checked={isChecked} value={value} onChange={onChange}>
        <Flex width="100%" justifyContent="space-between" pr={2} alignItems="center">
          <Text as="span">{value}</Text>
          <Text as="span" textStyle="p-sm" color="textTertiary">
            {count}
          </Text>
        </Flex>
      </Checkbox>
    ),
    [isChecked]
  );
}

export function KollectionsFilterGroupCheckboxList({
  traitType,
  values,
  styles,
}: StringTraitsWithCountType & {
  styles?: {
    container?: SystemStyleObject;
    traitCount?: SystemStyleObject;
    traitsContainer?: SystemStyleObject;
  };
}) {
  const { stringTraits, setStringTrait } = useKollections();
  const traitValuesSelected = stringTraits.find((el) => el.traitType === traitType)?.values;

  return useMemo(
    () => (
      <AccordionItem
        borderBottom="thin"
        py={4}
        {...styles?.container}
        css={{ '&:last-of-type': { borderBottom: 'none' } }}
        value={traitType}
      >
        <AccordionItemTrigger>
          <Flex alignItems="center">
            <Box fontWeight="medium" textTransform="uppercase">
              {traitType}
            </Box>
            {traitValuesSelected ? (
              <Center
                boxSize={5}
                ml={2}
                bg="backgroundTertiary"
                fontSize="xs"
                borderRadius="sm"
                {...styles?.traitCount}
              >
                {traitValuesSelected.length}
              </Center>
            ) : null}
          </Flex>
        </AccordionItemTrigger>
        <AccordionItemContent
          pl={0}
          pr={2}
          py={3}
          overflow="auto"
          maxHeight={pxToRem(300)}
          css={{
            ...customScrollbarStyles,
            ...styles?.traitsContainer,
          }}
        >
          <Grid gap={pxToRem(10)} css={{ '.chakra-checkbox__label': { flex: 1 } }}>
            {values.map(({ count, value }) => (
              <KollectionsFilterGroupCheckboxListItem
                key={value}
                isChecked={
                  traitValuesSelected ? traitValuesSelected.some((el) => el === value) : false
                }
                value={value}
                count={count}
                onChange={() => setStringTrait({ traitType, value })}
              />
            ))}
          </Grid>
        </AccordionItemContent>
      </AccordionItem>
    ),
    [traitValuesSelected]
  );
}
